import styled from 'styled-components';
import {dFlex, dFlexColumn, alignStart} from '../../../../../../globalVariables/GlobalFlex';
import {desktopMedia} from '../../../../../../globalVariables/GlobalVariables';

export const subMetrics = styled.div`
    ${dFlex}
    ${alignStart}
    gap: var(--space-sm);
    min-height: 42px;
`;

export const subMetric = styled.div`
    ${dFlexColumn}
    gap: var(--space-xs);
    &:not(:first-child){
        border-inline-start: 1px solid ${p => p.theme.isDarkMode ? 'rgba(255,255,255,0.15)' : 'var(--color-border-subtle)'};
        padding-inline-start: var(--space-md);
    }
`;

export const subLabel = styled.div`
    font-size: var(--font-size-caption);
    line-height: 1.33;
    color: ${p => p.theme.isDarkMode ? 'rgba(255,255,255,0.7)' : 'var(--color-text-default)'};
`;

export const subValue = styled.div`
    font-size: var(--font-size-text-metric-secondary); /* 20px, matches Figma heading-sub */
    line-height: 1.2;
    ${desktopMedia}{
        font-size: var(--font-size-body);
        line-height: 1.4;
    }
`;
